import { OnboardingFlowNode } from '@scale/shared/onboardingControlPanel';

export const nodeId = (node: OnboardingFlowNode | string): string => {
  if (typeof node === 'string') {
    return node;
  }
  return node.name;
};

export const FLOW_NODE_TYPE = 'flowNode';
export const FLOW_EDGE_TYPE = 'flowEdge';

const NODE_FIELDS = [
  'type',
  'name',
  'externalName',
  'externalDescription',
  'entryHooks',
  'exitHooks',
];
export const TERMINUS_FIELDS = [...NODE_FIELDS, 'destinationTeamId', 'success'];
export const STEP_FIELDS = [
  ...NODE_FIELDS,
  'stepType',
  'config',
  'disableDefaultFallbackValidation',
];
